module.exports = __webpack_public_path__ + "img/austria-leukaemia-male.46ec6d2f.png";